<script setup lang="ts">
import { useSlideoverToggle } from '~/composables/useSlideoverToggle';

defineProps<{
  onLogout:() => void;
}>();

const uuid = defineModel<string>('uuid', { required: true });
const { slideoverState } = useSlideoverToggle();
</script>

<template>
  <USlideover
    v-model:open="slideoverState"
    class="lg:hidden"
    side="left"
    :overlay="false"
    :ui="{
      wrapper: 'z-50 overflow-y-scroll',
      content: 'max-w-full xs:max-w-2xs',
    }"
  >
    <button
      class="block lg:hidden bg-white cursor-pointer z-20"
      type="button"
    >
      <UiFaIcon class="text-2xl text-gg-primary-700 font-bold" :icon="['far', 'fa-bars']" size="xl" />
    </button>
    <template #content>
      <LayoutSidebar
        v-model:uuid="uuid"
        :on-logout="onLogout"
        class="overflow-y-scroll"
      />
    </template>
  </USlideover>
  <div class="flex-1 flex justify-center items-center sm:hidden">
    <UiSvgGradGuard class="w-auto h-8" />
  </div>
  <div class="hidden lg:block w-full">
    <UAlert
      color="primary"
      variant="subtle"
      class="mb-0 text-left flex items-center justify-start"
      icon="i-lucide-sparkles"
    >
      <template #title>
        <span class="font-bold">Fresh Look, Same Protection.</span> Your Updated Member Portal Is Here!
      </template>
    </UAlert>
  </div>
</template>
